import { render } from "./TrendView.vue?vue&type=template&id=2ecd2c6a&ts=true"
import script from "./TrendView.vue?vue&type=script&lang=ts"
export * from "./TrendView.vue?vue&type=script&lang=ts"

import "./TrendView.vue?vue&type=style&index=0&id=2ecd2c6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__